var map = {
	"./Approve.png": 146,
	"./Cube.png": 222,
	"./Failed.png": 223,
	"./arrow-down-blue.svg": 482,
	"./arrow-down-grey.svg": 483,
	"./arrow-right-white.png": 484,
	"./arrow-right.svg": 485,
	"./bg.png": 219,
	"./big_unicorn.png": 217,
	"./blue-loader.svg": 486,
	"./busd.png": 487,
	"./circle-grey.svg": 488,
	"./circle.svg": 489,
	"./coinbaseWalletIcon.svg": 141,
	"./dappbg.png": 490,
	"./dappbg2.png": 491,
	"./dmod.png": 140,
	"./dmod.svg": 213,
	"./dmod2.png": 492,
	"./dmod2.svg": 224,
	"./dmodLogo.png": 493,
	"./dmodround.png": 111,
	"./dropdown-blue.svg": 494,
	"./dropdown.svg": 495,
	"./dropup-blue.svg": 496,
	"./ethereum-logo.png": 497,
	"./external.svg": 178,
	"./fortmaticIcon.png": 142,
	"./inch.png": 498,
	"./link.svg": 499,
	"./magnifying-glass.svg": 500,
	"./menu.svg": 501,
	"./metamask.png": 145,
	"./moonbeam.png": 109,
	"./moonbeam.svg": 502,
	"./moonbeam2.png": 503,
	"./moonbeamheader.png": 225,
	"./noise.png": 504,
	"./nologo.png": 505,
	"./notoken.png": 506,
	"./plus-blue.svg": 507,
	"./plus-grey.svg": 508,
	"./portisIcon.png": 143,
	"./question-mark.svg": 509,
	"./question.svg": 510,
	"./remove.png": 511,
	"./reward.png": 226,
	"./spinner.svg": 512,
	"./token-list-logo.png": 513,
	"./token-list/lists-dark.png": 514,
	"./token-list/lists-light.png": 515,
	"./token-logo.png": 227,
	"./tokenlistsgrouped.png": 516,
	"./trustWallet.png": 517,
	"./usdc.png": 221,
	"./usdt.png": 220,
	"./walletConnectIcon.svg": 144,
	"./x.svg": 518,
	"./xl_uni.png": 218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 189;